const ANONYMOUS_URLS = ["/session/refreshToken", "/session/login", "/session/tup"];
const DO_NOT_EXTEND_SESSION_URLS = ["/session/refreshToken", "/session/check"];

export const canRefreshToken = (url) => !DO_NOT_EXTEND_SESSION_URLS.includes(url);

const setTokens = (accessToken, refreshToken) => {
    localStorage.setItem("_t", accessToken);
    localStorage.setItem("_rt", refreshToken);
};

const getAccessToken = () => localStorage.getItem("_t");

export const getRefreshToken = () => localStorage.getItem("_rt");

const clearTokens = () => localStorage.clear();

const redirectToLogin = () => window.location.assign("/login");

export const processTokenError = (error) => {
    clearTokens();
    redirectToLogin();
    return Promise.reject(error);
};

export const authorizeRequest = (config) => {
    const t = getAccessToken();
    if (!t || ANONYMOUS_URLS.includes(config.url)) {
        return config;
    }
    config.headers = {
        Authorization: t,
    };

    return config;
};

export const doRefreshToken = async (currentRefreshToken, postFn) => {
    const response = await postFn({
        url: "/session/refreshToken",
        data: { refreshToken: currentRefreshToken },
    });
    const { accessToken, refreshToken } = response.data;
    setTokens(accessToken, refreshToken);
    return accessToken;
};
